import axios from 'axios';

const API_URL = 'https://nomical-app-production.up.railway.app/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true
});

// Health check
export const checkHealth = async () => {
  const response = await api.get('/health');
  return response.data;
};

// Database test
export const testDatabase = async () => {
  const response = await api.get('/db-test');
  return response.data;
};

// YouTube test
export const testYouTube = async () => {
  const response = await api.get('/test-youtube');
  return response.data;
};
// Saved codes endpoints
export const getSavedCodes = async () => {
  const token = localStorage.getItem('token');
  const response = await api.get('/saved-codes', {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export const saveCode = async (codeId) => {
  const token = localStorage.getItem('token');
  const response = await api.post('/saved-codes', 
    { code_id: codeId },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

export const unsaveCode = async (codeId) => {
  const token = localStorage.getItem('token');
  const response = await api.delete(`/saved-codes/${codeId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};
// Get all active discount codes
export const getCodes = async () => {
  const response = await api.get('/codes');
  return response.data;
};
export default api;
// Auth endpoints
export const signup = async (name, email, password) => {
  const response = await api.post('/auth/signup', { name, email, password });
  return response.data;
};

export const login = async (email, password) => {
  const response = await api.post('/auth/login', { email, password });
  return response.data;
};

export const logout = async () => {
  const response = await api.post('/auth/logout');
  return response.data;
};// Update
